<script lang="ts" setup>
// No script needed as we use single SVG with CSS
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    version="1.1"
    viewBox="0 0 1900.8 864"
    class="text-gray-900 dark:text-white"
  >
    <g>
      <g id="Capa_1">
        <g>
          <!-- Text and Black/White parts -->
          <path
            class="fill-current"
            d="M462.5,526.2v-187.7h77.8c14.1,0,26.7,2.5,37.8,7.5,11.1,5,19.8,12.2,26.1,21.7,6.3,9.5,9.5,20.9,9.5,34.2s-2.9,25-8.8,34.4c-5.9,9.4-14.4,16.6-25.5,21.6s-24.6,7.4-40.3,7.4h-27.2v60.9h-49.3ZM511.8,424.5h25.5c8.5,0,15.1-1.7,19.9-5,4.8-3.3,7.2-8.9,7.2-16.8s-2.5-13.7-7.4-17.1-11.4-5-19.4-5h-25.7v43.8Z"
          />
          <path
            class="fill-current"
            d="M640.7,526.2v-187.7h49.3v187.7h-49.3Z"
          />
          <path
            class="fill-current"
            d="M732.7,526.2v-187.7h77.9c14.3,0,26.8,2.3,37.5,6.8,10.7,4.6,18.9,11.1,24.8,19.8,5.9,8.6,8.8,19.1,8.8,31.3s-1.7,17.1-5,24.1c-3.4,6.9-7.9,12.8-13.6,17.5-5.7,4.7-12.1,8.3-19.2,10.7l48.4,77.5h-58.3l-38.5-66.9h-13.4v66.9h-49.3ZM782,420.3h23.1c8.3,0,14.9-1.6,19.6-4.8,4.8-3.2,7.2-8.5,7.2-15.9s-2.3-12.9-6.9-16.1c-4.6-3.2-11-4.8-19.2-4.8h-23.7v41.6Z"
          />
          <path
            class="fill-current"
            d="M918.9,526.2v-187.7h49.3v187.7h-49.3Z"
          />
          <path
            class="fill-current"
            d="M1010.9,526.2v-187.7h135.5v42.6h-86.2v29.6h71.5v39.1h-71.5v33.1h87.3v43.2h-136.6Z"
          />
          <path
            class="fill-current"
            d="M1183.1,526.2v-187.7h49.1l71.5,107.9v-107.9h47.7v187.7h-49.1l-71.5-109.5v109.5h-47.7Z"
          />
          <path
            class="fill-current"
            d="M1481.4,530.2c-19.5,0-36.7-4-51.5-11.9-14.9-7.9-26.5-19.1-34.9-33.7-8.4-14.6-12.5-31.8-12.5-51.6s2.4-27.7,7.3-39.8c4.9-12.1,11.8-22.5,20.7-31.2,8.9-8.8,19.5-15.5,31.6-20.3,12.2-4.8,25.5-7.2,39.9-7.2s29.6,2,40.3,6.1c10.7,4.1,20.4,9.9,29.3,17.4l-24.4,40.5c-5-5.3-11.1-9.2-18.2-11.9-7.1-2.7-15-4-23.8-4s-15.4,1.2-21.7,3.5c-6.3,2.3-11.7,5.7-16,10-4.3,4.3-7.6,9.6-9.9,15.7-2.3,6.1-3.4,13-3.4,20.7s2.1,19.3,6.2,26.7c4.1,7.4,10,13.1,17.8,17.1,7.7,4,17,6,28,6s16.1-1.3,24.2-3.8c8.1-2.5,15.8-6.4,23.1-11.8l22.5,41.3c-8.6,6.5-19,11.9-31.2,16.1-12.2,4.2-26.7,6.3-43.3,6.3Z"
          />
          <path
            class="fill-current"
            d="M1581.4,526.2v-187.7h135.5v42.6h-86.2v29.6h71.5v39.1h-71.5v33.1h87.3v43.2h-136.6Z"
          />
          <!-- Teal Part -->
          <polygon
            fill="#00a0a0"
            points="224.1 338.6 164.8 338.6 227.5 432.8 166.3 526.2 224.1 526.2 285.9 432.3 224.1 338.6"
          />
          <polygon
            fill="none"
            points="348.6 387.9 348.6 387.9 335.5 368.2 348.6 387.9"
          />
          <polygon
            class="fill-current"
            points="439 338.5 381.2 338.5 364.3 364.2 393.5 408.1 439 338.5"
          />
          <polyline
            class="fill-current"
            points="315.8 338.7 315.8 338.7 257.5 338.7 319.3 432.3 257.5 525.9 316.4 525.9 348.6 476.7 381.2 526.1 440.5 526.1 440.5 526.1 440.5 526.1"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
